//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The api error model
* 
* @param status The error status code
* @param type The error status code
* @param detail The error details
* @param instance The error uri
* @param properties The error properties (spring uses this)
* @param title The error message
*/
@Serializable

data class ApiError (


      /* The error status code */
    @SerialName(value = "status") @Required val status: kotlin.Int,


      /* The error status code */
    @SerialName(value = "type") @Required val type: kotlin.String,


      /* The error details */
    @SerialName(value = "detail") val detail: kotlin.String? = null,


      /* The error uri */
    @SerialName(value = "instance") val instance: kotlin.String? = null,


      /* The error properties (spring uses this) */
    @SerialName(value = "properties") val properties: kotlin.collections.Map<kotlin.String, kotlinx.serialization.json.JsonObject>? = null,


      /* The error message */
    @SerialName(value = "title") val title: kotlin.String? = null


) {




  }

